import React from 'react';
import { useSelector } from 'react-redux';

// components
import { HeaderNav } from 'app-components';

// selectors
import { environmentSelector } from '../../../selectors/commonSelectors';

// constants
import { configs } from '../../../constants/configs/configs';

//Hooks
import { useTopNavMenu } from '../../../hooks/useTopNavMenu';


const TopNavHeader = () => {
    const {
        stateCode,
        user: {
            role,
            roles,
            roleLabels,
            userActiveRole
        }
    } = useSelector(environmentSelector);
    const { endpoints } = configs;
    const roleLabel = sessionStorage.getItem('userActiveRoleLabel')|| roleLabels[userActiveRole];
    const { TopNavMenuComponent } = useTopNavMenu(userActiveRole, roleLabel, roleLabels, roles, role, endpoints);

    return (
        <HeaderNav isTopNav={true} stateCode={stateCode} hasSubMenu={true}>
            <TopNavMenuComponent />
        </HeaderNav>
    );
};
export default TopNavHeader;